import styled, { createGlobalStyle } from 'styled-components';

/**
 * `Layout` trzyma treść strony w kontenerze z `max-width: 1600px` i
 * automatycznymi marginesami. Dla edytora to widoczna szpara przy sidebarze na
 * szerokim ekranie, więc na czas jego wyświetlania zdejmujemy limit z rodzica
 * planszy. Reguła celuje wyłącznie w kontener, który zawiera nasz widok, i
 * znika razem z odmontowaniem komponentu.
 */
export const FullBleedEditorStyles = createGlobalStyle`
  div:has(> [data-ads-editor]) {
    max-width: none;
    padding: 0;
  }
`;

/**
 * Wysokość okna pomniejszona o pasek aplikacji (TopBar 60px + padding
 * nagłówka i linia oddzielająca). Edytor sam rozdziela to miejsce między
 * panele i planszę, więc nie dziedziczy marginesów `PageWrapper`.
 */
export const EditorViewport = styled.div`
  height: calc(100vh - 72px);
  width: 100%;
`;
